import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './Stats.css';

const Stats = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [counts, setCounts] = useState({ years: 0, projects: 0, satisfaction: 0 });

  useEffect(() => {
    const handleScroll = () => {
      const statsSection = document.querySelector('.stats-section');
      if (statsSection) {
        const rect = statsSection.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8 && !isVisible) {
          setIsVisible(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const frameRate = 60;
    const totalFrames = Math.round(duration / (1000 / frameRate));
    
    const counters = {
      years: { target: 30, current: 0 },
      projects: { target: 300, current: 0 },
      satisfaction: { target: 98, current: 0 }
    };

    let frame = 0;
    const timer = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);

      setCounts({
        years: Math.round(easeOutQuart * counters.years.target),
        projects: Math.round(easeOutQuart * counters.projects.target),
        satisfaction: Math.round(easeOutQuart * counters.satisfaction.target)
      });

      if (frame >= totalFrames) {
        clearInterval(timer);
        setCounts({
          years: counters.years.target,
          projects: counters.projects.target,
          satisfaction: counters.satisfaction.target
        });
      }
    }, 1000 / frameRate);

    return () => clearInterval(timer);
  }, [isVisible]);

  const statsData = [
    { number: counts.years, label: t('stats.years'), suffix: '' },
    { number: counts.projects, label: t('stats.projects'), suffix: '+' },
    { number: counts.satisfaction, label: t('stats.satisfaction'), suffix: '%' }
  ];

  return (
    <section className="stats-section">
      <div className="stats-container">
        {statsData.map((stat, index) => (
          <motion.div
            key={index}
            className={`stat-item ${isVisible ? 'visible' : ''}`}
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <div className="stat-number">
              {stat.suffix === '%' && stat.suffix}
              {stat.number}
              {stat.suffix !== '%' && stat.suffix}
            </div>
            <div className="stat-label">{stat.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
